@if (displayCard) {
  <div class="md:flex md:flex-col md:items-center">
    <div class="px-5 pb-3 md:w-8/12">
      <div
        class="flex flex-col gap-2 p-5 md:p-6 mb-3 md:mb-8 rounded-m"
        [style.backgroundColor]="backgroundColor | contentBuilderColor: 'neutral-100'"
      >
        @if (title) {
          <div
            class="text-md md:text-29px font-accent font-bold"
            [style.color]="textColor | contentBuilderColor: 'neutral-800'"
          >
            {{ title }}
          </div>
        }
        @if (content) {
          <div
            class="font-base text-sm md:text-base"
            [style.color]="textColor | contentBuilderColor: 'neutral-800'"
          >
            <app-text-atom [content]="content"></app-text-atom>
          </div>
        } @else if (text) {
          <div
            class="text-md md:text-29px font-accent font-bold"
            [style.color]="textColor | contentBuilderColor: 'neutral-800'"
          >
            <p>{{ text }}</p>
          </div>
        }
      </div>
    </div>
  </div>
}
